export default () => ({
  isShowPrice: false
})



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/professional/resources/data.js